import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { lerRascunhoAberto, type RascunhoAberto } from '@/lib/rascunhoInscricao';

// ---------------------------------------------------------------------------
// "Continuar sua inscrição": só aparece quando existe um rascunho guardado no
// aparelho E a participação ainda está aberta AGORA (janela de inscrições +
// evento no futuro). Se fechou, o rascunho é apagado em silêncio e nada
// aparece. Só é usado dentro do app instalado (ver AppInicio).
// ---------------------------------------------------------------------------

export default function CartaoContinuarInscricao() {
  const navigate = useNavigate();
  const [salvo, setSalvo] = useState<RascunhoAberto | null>(null);

  useEffect(() => {
    let ativo = true;
    void lerRascunhoAberto().then((dado) => {
      if (ativo) setSalvo(dado);
    });
    return () => {
      ativo = false;
    };
  }, []);

  if (!salvo) return null;

  return (
    <div className="app-entra mt-3 rounded-[22px] border border-primary-200 bg-primary-50 p-4">
      <div className="flex items-center gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600">
          <i className="ri-file-list-3-line text-[20px]" aria-hidden />
        </span>
        <div className="min-w-0 flex-1">
          <p className="text-[15px] font-extrabold text-foreground-950">Continuar sua inscrição</p>
          <p className="mt-0.5 truncate text-[13px] text-foreground-600">{salvo.nome}</p>
        </div>
      </div>
      <button
        type="button"
        onClick={() => navigate(`/e/${salvo.slug}?c=${encodeURIComponent(salvo.codigo)}`)}
        className="aperta mt-3 flex h-12 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-[16px] bg-primary-500 text-[15px] font-bold text-white transition-colors hover:bg-primary-600"
      >
        <span className="flex h-5 w-5 items-center justify-center">
          <i className="ri-arrow-right-line" aria-hidden />
        </span>
        Continuar
      </button>
    </div>
  );
}